// extracted by mini-css-extract-plugin
export default {"tableWrapper":"CharactersDashboard_tableWrapper__5Ad0u"};